export default "assets/images/icons/3d-54486b40.svg";